<template>
  <div
    class="absolute bg-white inset-0 opacity-50"
  />
</template>

<script>
export default {
  name: 'Loader',
};
</script>
